import {trackComponent} from '@aboutyou/legacy-tracking-sdk';
import {WithOptionalTypes} from '@aboutyou/utils';
import {useCallback} from 'react';
import {useTrackingPageContext} from '../context/PageTrackingContext';
import {useTracking} from '../utils/utils';

type TrackComponentCallbackType = Omit<
  Parameters<typeof trackComponent>[0],
  | 'page_type'
  | 'details'
  | 'abtest_flag'
  | 'event_scope'
  | 'object_details'
  | 'event'
>;

type TrackComponentCallbackTypePartial = WithOptionalTypes<
  TrackComponentCallbackType,
  'sponsored' | 'page_type_id'
>;

export type TrackComponentParamsType = Pick<
  TrackComponentCallbackTypePartial,
  'location_id' | 'page_type_id'
>;

export const useTrackComponent = () => {
  const {TrackingClient} = useTracking();
  const {type: page_type, id} = useTrackingPageContext();

  return useCallback(
    ({
      page_type_id = '',
      sponsored = false,
      ...rest
    }: TrackComponentCallbackTypePartial) => {
      TrackingClient.track(
        trackComponent({
          page_type,
          page_type_id: page_type_id || (id ? id.toString() : ''),
          sponsored,
          ...rest,
        }),
      );
    },
    [TrackingClient, id, page_type],
  );
};
